(ns core.front.feature-flags
  (:require [core.feature-flag.model :as feature-flag-model]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]
            [schema.core :as s]))

(def ^:private *enabled-flags
  (r/atom #{}))

(defn reset-flags! [feature-flags] (reset! *enabled-flags feature-flags))

(defn- enabled-impl? [flag-id]
  (contains? @*enabled-flags flag-id))

(s/defn enabled? :- s/Bool [flag-id :- feature-flag-model/FlagId]
  (enabled-impl? flag-id))

(defn enabled-or-removed?
  "Use for flags stored in e.g. database. Use `enabled?` when the flag is a literal in code, i.e.
   the check itself can be removed when the flag is removed."
  [flag-id]
  (or (enabled-impl? flag-id)
      (nil? (feature-flag-model/get-model flag-id))))

(rf/reg-sub ::enabled-flags
  (constantly *enabled-flags)
  :-> identity)

(rf/reg-sub ::enabled?
  :<- [::enabled-flags]
  :=> contains?)

(rf/reg-sub ::disabled?
  (fn [[_ flag]]
    (rf/subscribe [::enabled? flag]))
  :-> not)

(rf/reg-fx ::toggle
  (fn [[id enabled?]]
    (swap! *enabled-flags (comp set (if enabled? conj disj)) id)))
